export default {
  // หัวข้อ / chrome
  bellTitle: "แจ้งเตือนของคุณ",
  viewAll: "ดูแจ้งเตือนทั้งหมด",
  pageTitle: "แจ้งเตือนทั้งหมด",

  // แท็บ
  tabAll: "ทั้งหมด",
  tabUnread: "ยังไม่ได้อ่าน",
  tabRead: "อ่านแล้ว",

  // สถานะว่าง
  selectBusiness: "กรุณาเลือกโปรไฟล์ธุรกิจ เพื่อดูการแจ้งเตือน",
  noAlert: "ยังไม่มีแจ้งเตือน",
  noNew: "ยังไม่มีแจ้งเตือนใหม่",
  noList: "ยังไม่มีรายการแจ้งเตือน",
  notFound: "ไม่พบรายการแจ้งเตือนที่ต้องการ",
  checkAgain: "กรุณาตรวจสอบใหม่อีกครั้งหรือ ติดต่อเจ้าหน้าที่ผู้ดูแล",

  // ค่าเริ่มต้น
  unnamed: "ไม่ระบุชื่อ",
  notSpecified: "ไม่ระบุ",

  // ปุ่ม
  viewProfile: "ดูโปรไฟล์ผู้สมัคร",

  // คำอธิบาย
  descViewProfile: "คุณสามารถดูโปรไฟล์ผู้สมัครงานได้",
  descViewStatusList:
    "คุณสามารถดูรายการสถานะของผู้สมัครงานตำแหน่ง {position} ทั้งหมดได้",

  // ข้อความแจ้งเตือน
  msgApplied: "{name} ได้สมัครเข้าทำงานในตำแหน่ง {position}",
  msgEditApply: "{name} ได้แก้ไขใบสมัครเข้าทำงานในตำแหน่ง {position}",
  msgOfferByYou:
    "คุณได้ยื่นข้อเสนอเข้าทำงานในตำแหน่ง {position} ให้กับ {name} เรียบร้อยแล้ว",
  msgOfferByOther:
    "ผู้ดูแลท่านอื่นได้ยื่นข้อเสนอเข้าทำงานในตำแหน่ง {position} ให้กับ {name} เรียบร้อยแล้ว",
  msgStatusByYou:
    "คุณได้ทำการเปลี่ยนสถานะใบสมัครตำแหน่ง {position} ของ {name} เป็น {status} เรียบร้อยแล้ว",
  msgStatusByOther:
    "ผู้ดูแลท่านอื่นเปลี่ยนสถานะใบสมัครตำแหน่ง {position} ของ {name} เป็น {status} เรียบร้อยแล้ว",
  msgPaymentInProgress:
    "ผู้สมัคร {name} ในตำแหน่ง {position} อยู่ระหว่างชำระเงิน",

  // ชื่อสถานะ
  status: {
    Pending: "ยังไม่มีข้อมูล",
    Interested: "สนใจ",
    "Pass Screening": "รับ",
    "Not Pass Screening": "ไม่รับ",
    "Pass Interview": "รับเข้าทำงาน",
    "Not Pass Interview": "ไม่ผ่านสัมภาษณ์",
    "Waiting Payment": "รอชำระเงิน",
    "Payment Success": "ชำระเงินสำเร็จ",
    "Payment In Progress": "อยู่ระหว่างชำระเงิน",
    "Payment Expired": "หมดเขต",
    "Interview In Progress": "สัมภาษณ์อยู่ระหว่างดำเนินการ",
    "Waiting Interview": "รอสัมภาษณ์",
    "Miss Interview": "ไม่มาสัมภาษณ์",
  },
};
